import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tributario/servico/';

class ServicosService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllServicos(idCliente) {
        return axios.get(API_URL + 'all?idCliente='+idCliente, {headers: this.headers});
    }

    findAllByClienteFiltro(filtro, idCliente) {
        return axios.get(API_URL + 'filter?filtro='+filtro+'&idCliente='+idCliente, {headers: this.headers}).then(response => (this.data = response.data));
    }
}

export default new ServicosService();